export default {
    SUMMARY_REPORT_DETAILS: "summaryReport"
};
